import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const asyncValidateEmail = (email, index) => {
  const object = {
    email,
    id: customerId()
  };
  if (!email || email === '') {
    return Promise.resolve();
  }
  const errors = {
    emails: []
  };
  errors.emails[index] = {
    email: 'Email is already in use'
  };

  return axios
    .post(
      `${getV1RootUrl()}/customer/is-unique-email`,
      object,
      publicAxiosHeader()
    )
    .then((response) => {
      if (response.data === false) {
        return errors;
      }
      return null;
    })
    .catch(() => {
      errors.emails[index] = {
        email: 'Unknown error checking for unique email'
      };
      return errors;
    });
};

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;

export const asyncValidateEmailNotArray = async (email) => {
  const object = {
    email
  };
  if (!email || email === '') {
    return null;
  }
  let errors = {
    email: 'Email is already in use'
  };

  try {
    const response = await axios.post(
      `${getV1RootUrl()}/customer/is-unique-email`,
      object,
      publicAxiosHeader()
    );
    if (response.data === false) {
      return errors;
    }
    return null;
  } catch {
    errors = {
      email: 'Unknown error checking for unique email'
    };
    return errors;
  }
};

export const asyncValidatePassword = async (password) => {
  const object = {
    password
  };
  if (!password || password === '') {
    return null;
  }
  const errors = {
    password: 'Password is too weak.  Please alter it to make it stronger.'
  };

  try {
    await axios.post(
      `${getV1RootUrl()}/customer/password-strength-check`,
      object,
      publicAxiosHeader()
    );
    return null;
  } catch (err) {
    let errorMessage;
    if (err.response?.data?.errors) {
      const error = err.response.data.errors.find(
        (e) => e.field === 'password'
      );
      errorMessage = error.message;
    }
    if (errorMessage) {
      return { password: errorMessage };
    }
    return errors;
  }
};

export const asyncValidateEmailAndPassword = async (email, password) => {
  const emailResult = await asyncValidateEmailNotArray(email);
  const passwordResult = await asyncValidatePassword(password);
  let isErrors = false;
  const errors = {};

  if (emailResult) {
    errors.email = emailResult.email;
    isErrors = true;
  }
  if (passwordResult) {
    errors.password = passwordResult.password;
    isErrors = true;
  }
  if (!isErrors) {
    return null;
  }
  return errors;
};
